const initialState = { expenses: null, fetchedDate: null };

const expensesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_EXPENSES": {
      const { data } = action;

      let memberships = state.expenses || []
      let dates = state.fetchedDate || []
      data.map((membership) => {
        if (!dates.find((date) => date === membership.date)) {
          const newMembers = data.filter(a => a.date === membership.date)
          memberships = memberships.concat(newMembers)
          dates.push(membership.date)
        }
      })

      return {
        ...state,
        expenses: memberships,
        fetchedDate: dates
      }
    };

    case "CREATE_EXPENSES": {
      let dt = state.expenses.concat(action.data);
      return {
        ...state,
        expenses: dt,
      };
    }
    case "UPDATE_EXPENSES": {
      let dt = state.expenses.map((order) => {
        if (order._id === action.data._id) {
          return action.data;
        }
        return order;
      });
      return {
        ...state,
        expenses: dt,
      }
    };
    case "DELETE_EXPENSES": {
      let dt = state.expenses.filter((a) => a._id !== action.data);
      return {
        ...state,
        expenses: dt,
      };
    }
    default:
      return state;
  }
};

export default expensesReducer;
